import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'moment',
})
export class MomentPipe implements PipeTransform {
  transform(value: Date): Date {
    return value;
    // .toLocaleString('en-US', {
    //   timeZone: localStorage.getItem('timeZone'),
    // });
  }
  constructor() {}
}
